export const helpTextFinder = (formData, dayConsumptionElement) => {
  if (
    formData.invoiceType === "g23" &&
    formData.knowledgeOfConsumption === true
  ) {
    return dayConsumptionElement.helpTextKnownConsumptionNight;
  }
  if (
    formData.invoiceType === "g22" &&
    formData.knowledgeOfConsumptionForLead === true
  ) {
    return dayConsumptionElement.helpTextKnownConsumptionMonthly;
  }

  if (formData.knowledgeOfConsumption === false) {
    return dayConsumptionElement.helpText;
  }

  return dayConsumptionElement.helpTextKnownConsumption;
};

export const helpTitleFinder = (formData, dayConsumptionElement) => {
  if (formData.invoiceType === "g23") {
    return dayConsumptionElement.helpTitleNight;
  }
  if (formData.invoiceType === "g22") {
    return dayConsumptionElement.helpTitleMonthly;
  }
  return dayConsumptionElement.helpTitle;
};
export const helpImageFinderDayConsumption = (formData, dayConsumptionElement) => {
  if (formData.invoiceType === "g22") {
    return dayConsumptionElement.helpExampleImageUrlMonthly;
  }
  if(formData.invoiceType === "g23"){
    return dayConsumptionElement.helpExampleImageUrlDaily;
  }
  return dayConsumptionElement.helpExampleImageUrl;
};
export const helpImageFinderInvoiceType = (formData,invoiceTypeElement) => {
  if (formData.invoiceType === "g21") {
    return invoiceTypeElement.helpExampleImageUrl;
  }
  if (formData.invoiceType === "g23") {
    return invoiceTypeElement.helpExampleImageUrlG23;
  }
  if (formData.invoiceType === "g22") {
    return invoiceTypeElement.helpExampleImageUrlG22;
  }
  return invoiceTypeElement.helpExampleImageUrl
}
